import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/accordions/FaqFullPage.jsx");
;
import(/* webpackMode: "eager" */ "/app/components/common/ParallaxContainer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/gitbiz/interview/Layouts.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
